import { render, staticRenderFns } from "./ValidateAnnouncementDEPS.vue?vue&type=template&id=3e1aff0f&scoped=true"
import script from "./ValidateAnnouncementDEPS.vue?vue&type=script&lang=js"
export * from "./ValidateAnnouncementDEPS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1aff0f",
  null
  
)

export default component.exports